import { render, staticRenderFns } from "./allBranchTransactions.vue?vue&type=template&id=17033900&scoped=true"
import script from "./allBranchTransactions.vue?vue&type=script&lang=js"
export * from "./allBranchTransactions.vue?vue&type=script&lang=js"
import style0 from "./allBranchTransactions.vue?vue&type=style&index=0&id=17033900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17033900",
  null
  
)

export default component.exports